import { Row, Col, Tag } from 'antd';
export * from 'antd/es/grid';
export { Row, Col, Tag };
